import React, { useState } from 'react';
import styled from 'styled-components';
import { CommonNoteLayout } from '../../base/CommonNote';
import { VodLayout } from '../../base/vod';
import { ShareDocumentLayout } from '../../share-document';
import { layoutList, layoutType, videoLayoutMode } from '../constants';
import ScreenFilm from './ScreenFilm';
import SliderFilm from './SlideFilm';
import UserFilm from './UserFilm';

const MainConentStyled = styled.div`
    width: 100%;
    flex: 1;
    overflow: auto;

    & .item {
        padding-bottom: ${props => (props.isVideoMode ? 0 : '56.25%')};
    }
`;

const MobileStyled = styled.div`
    display: flex;
    width: 100%;
    flex: 1;
    flex-direction: column;
    height: 100%;

    & .item {
        width: 100%;

        & .videoWrap {
            position: absolute !important;

            & .default {
                width: 100%;
                height: 100%;
                position: relative;
            }
        }
    }
`;

function MobileMode({ mode, type, userAgentType, resize, roomCode }) {
    const [ isLeftOpen, setLeftOpen ] = useState(false);
    const [ page, setPage ] = useState(0);

    const mainContent = () => {
        switch (mode) {
            case videoLayoutMode.document:
            case videoLayoutMode.white:
                return (
                    <ShareDocumentLayout
                        expand="false"
                        mobile={true}
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}
                        resize={resize}
                    />
                );

            case videoLayoutMode.note:
                return (
                    <CommonNoteLayout
                        expand={false}
                        mobile={true}
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}
                        roomCode={roomCode}
                        style={{
                            width: '100%',
                            height: '100%',
                            boxSizing: 'border-box',
                            border: 'none',
                        }}
                    />
                );

            case videoLayoutMode.screen:
                return (
                    <ScreenFilm type={layoutType.mobile} />
                );

            case videoLayoutMode.vod:
                return (
                    <VodLayout
                        expand={false} 
                        mobile={true} 
                        isLeftOpen={isLeftOpen}
                        setLeftOpen={setLeftOpen}
                        resize={resize}
                    /> 
                )
                
            default:
                if (userAgentType === layoutType.desktop) { 
                    return (
                        <UserFilm isVertical={true} />
                    );    
                }

                return (
                    <SliderFilm
                        type={type}
                        page={page}
                        setPage={setPage}
                        mode={mode}
                        resize={resize}
                    />
                );

        }
    };

    const isVideoMode = layoutList.indexOf(mode) !== -1 && userAgentType !== layoutType.desktop;

    return (
        <MobileStyled>
            <MainConentStyled isVideoMode={isVideoMode}>
                { mainContent() }
            </MainConentStyled>
        </MobileStyled>
    );
}

export default MobileMode;
